<template>
  <CContainer fluid>
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>Dev Peoples Debug</CCardHeader>
          <CCardBody>
            <CTabs variant="pills" @update:activeTab="onTabChange">
              <CTab title="Peoples">
                <CRow class="mt-3">
                  <CCol sm="4">
                    <label>Search</label>
                    <CInput v-model="filters.search" placeholder="name or email" />
                  </CCol>
                  <CCol sm="2">
                    <label>Status</label>
                    <b-form-select v-model="filters.status" :options="statusOptions"></b-form-select>
                  </CCol>
                  <CCol sm="2">
                    <label>Active</label>
                    <b-form-select v-model="filters.is_active" :options="activeOptions"></b-form-select>
                  </CCol>
                  <CCol sm="2">
                    <label>Portal Access</label>
                    <b-form-select v-model="filters.has_portal_access" :options="portalOptions"></b-form-select>
                  </CCol>
                  <CCol sm="2" class="d-flex align-items-end">
                    <CButton color="info" class="mr-2" @click="applyFilter">Apply</CButton>
                    <CButton color="secondary" @click="resetFilter">Reset</CButton>
                  </CCol>
                </CRow>

                <table class="table table-bordered table-sm mt-3">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Has Portal Access</th>
                      <th>Status</th>
                      <th>Record Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in rows" :key="row.people_uuid">
                      <td>{{ row.name }}</td>
                      <td>{{ row.email || '-' }}</td>
                      <td>
                        <CBadge :color="row.has_portal_access ? 'success' : 'secondary'">
                          {{ row.has_portal_access ? 'Yes' : 'No' }}
                        </CBadge>
                      </td>
                      <td>{{ row.status || '-' }}</td>
                      <td>
                        <CBadge :color="row.record_status === 'Active' ? 'success' : 'danger'">
                          {{ row.record_status || '-' }}
                        </CBadge>
                      </td>
                      <td>
                        <CButton size="sm" color="primary" @click="goDetail(row.people_uuid)">Show Detail</CButton>
                      </td>
                    </tr>
                    <tr v-if="rows.length === 0">
                      <td colspan="6" class="text-center">No data</td>
                    </tr>
                  </tbody>
                </table>

                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    Showing {{ meta.from || 0 }} - {{ meta.to || 0 }} of {{ meta.total || 0 }}
                  </div>
                  <b-pagination
                    v-model="page"
                    :total-rows="meta.total || 0"
                    :per-page="perPage"
                    @change="loadData"
                  ></b-pagination>
                </div>
              </CTab>

              <CTab :title="orphanUsersTabTitle">
                <CRow class="mt-3">
                  <CCol sm="4">
                    <label>Search</label>
                    <CInput v-model="orphanFilters.search" placeholder="email or username" />
                  </CCol>
                  <CCol sm="2">
                    <label>Active</label>
                    <b-form-select v-model="orphanFilters.is_active" :options="activeOptions"></b-form-select>
                  </CCol>
                  <CCol sm="2" class="d-flex align-items-end">
                    <CButton color="info" class="mr-2" @click="applyOrphanFilter">Apply</CButton>
                    <CButton color="secondary" @click="resetOrphanFilter">Reset</CButton>
                  </CCol>
                </CRow>

                <p class="text-muted mt-2">
                  User accounts whose email has no matching record in the peoples table.
                </p>

                <table class="table table-bordered table-sm mt-3">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Username</th>
                      <th>Roles</th>
                      <th>Record Status</th>
                      <th>Last Login</th>
                      <th>Created At</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in orphanRows" :key="row.email + row.username">
                      <td>{{ row.email || '-' }}</td>
                      <td>{{ row.username || '-' }}</td>
                      <td>
                        <CBadge v-for="role in row.roles" :key="role" color="info" class="mr-1">
                          {{ role }}
                        </CBadge>
                        <span v-if="!row.roles || row.roles.length === 0">-</span>
                      </td>
                      <td>
                        <CBadge :color="row.record_status === 'Active' ? 'success' : 'danger'">
                          {{ row.record_status || '-' }}
                        </CBadge>
                      </td>
                      <td>{{ row.last_login || '-' }}</td>
                      <td>{{ row.created_at || '-' }}</td>
                      <td>
                        <CButton size="sm" color="primary" @click="showOrphanDetail(row)">Show Detail</CButton>
                      </td>
                    </tr>
                    <tr v-if="orphanRows.length === 0">
                      <td colspan="7" class="text-center">No data</td>
                    </tr>
                  </tbody>
                </table>

                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    Showing {{ orphanMeta.from || 0 }} - {{ orphanMeta.to || 0 }} of {{ orphanMeta.total || 0 }}
                  </div>
                  <b-pagination
                    v-model="orphanPage"
                    :total-rows="orphanMeta.total || 0"
                    :per-page="orphanPerPage"
                    @change="loadOrphanUsers"
                  ></b-pagination>
                </div>
              </CTab>
            </CTabs>
          </CCardBody>
        </CCard>

        <CModal
          title="User Detail"
          color="info"
          :show.sync="orphanDetailVisible"
        >
          <pre style="white-space: pre-wrap;">{{ orphanDetailPretty }}</pre>
          <template #footer>
            <CButton color="secondary" @click="orphanDetailVisible = false">Close</CButton>
          </template>
        </CModal>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import devService from '@/services/dev'

export default {
  data() {
    return {
      rows: [],
      meta: {},
      page: 1,
      perPage: 10,
      filters: {
        search: '',
        status: '',
        is_active: 'all',
        has_portal_access: ''
      },
      statusOptions: [
        { text: 'All', value: '' },
        { text: 'member', value: 'member' },
        { text: 'visitor', value: 'visitor' },
        { text: 'newcomer', value: 'newcomer' }
      ],
      activeOptions: [
        { text: 'All', value: 'all' },
        { text: 'Active', value: 'active' },
        { text: 'Inactive', value: 'inactive' }
      ],
      portalOptions: [
        { text: 'All', value: '' },
        { text: 'Yes', value: '1' },
        { text: 'No', value: '0' }
      ],

      orphanLoaded: false,
      orphanRows: [],
      orphanMeta: {},
      orphanPage: 1,
      orphanPerPage: 10,
      orphanFilters: {
        search: '',
        is_active: 'all'
      },
      orphanDetailVisible: false,
      orphanDetailRow: null
    }
  },
  computed: {
    orphanUsersTabTitle() {
      if (!this.orphanLoaded) {
        return 'Users without People'
      }
      return `Users without People (${this.orphanMeta.total || 0})`
    },
    orphanDetailPretty() {
      return this.orphanDetailRow ? JSON.stringify(this.orphanDetailRow, null, 2) : ''
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    onTabChange(tabIndex) {
      if (tabIndex === 1 && !this.orphanLoaded) {
        this.loadOrphanUsers()
      }
    },
    buildParams() {
      return {
        page: this.page,
        per_page: this.perPage,
        search: this.filters.search,
        status: this.filters.status,
        is_active: this.filters.is_active,
        has_portal_access: this.filters.has_portal_access,
        sort_by: 'name',
        sort_dir: 'asc'
      }
    },
    loadData() {
      devService.getDevPeoples(this.buildParams())
        .then((res) => {
          const data = res.data || {}
          this.rows = data.rows || []
          this.meta = data
        })
        .catch((err) => {
          alert((err.response && err.response.data && err.response.data.message) || 'Failed to load data')
        })
    },
    applyFilter() {
      this.page = 1
      this.loadData()
    },
    resetFilter() {
      this.filters = {
        search: '',
        status: '',
        is_active: 'all',
        has_portal_access: ''
      }
      this.page = 1
      this.loadData()
    },
    goDetail(peopleUuid) {
      this.$router.push({ name: 'Dev People Detail', params: { people_uuid: peopleUuid } })
    },

    buildOrphanParams() {
      return {
        page: this.orphanPage,
        per_page: this.orphanPerPage,
        search: this.orphanFilters.search,
        is_active: this.orphanFilters.is_active
      }
    },
    loadOrphanUsers() {
      devService.getDevUsersWithoutPeople(this.buildOrphanParams())
        .then((res) => {
          const data = res.data || {}
          this.orphanRows = data.rows || []
          this.orphanMeta = data
          this.orphanLoaded = true
        })
        .catch((err) => {
          alert((err.response && err.response.data && err.response.data.message) || 'Failed to load data')
        })
    },
    applyOrphanFilter() {
      this.orphanPage = 1
      this.loadOrphanUsers()
    },
    resetOrphanFilter() {
      this.orphanFilters = {
        search: '',
        is_active: 'all'
      }
      this.orphanPage = 1
      this.loadOrphanUsers()
    },
    showOrphanDetail(row) {
      this.orphanDetailRow = row
      this.orphanDetailVisible = true
    }
  }
}
</script>
